import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

// Add Blog
export const add_blog = createAsyncThunk(
  "blog/add_blog",
  async (
    { name, image, subTitle, writtenBy, description },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("image", image);
      formData.append("subTitle", subTitle);
      formData.append("writtenBy", writtenBy);
      formData.append("description", description);

      const { data } = await api.post("/add-blog", formData, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Blogs
export const get_blogs = createAsyncThunk(
  "blog/get_blogs",
  async (
    { parPage, page, searchValue },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.get(
        `/get-blogs?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`,
        { withCredentials: true }
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Get All Blogs
export const get_all_blogs = createAsyncThunk(
  "blog/get_all_blogs",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get("/get-all-blogs", {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Delete Blog
export const delete_blog = createAsyncThunk(
  "blog/delete_blog",
  async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(`/delete-blog?id=${id}`, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const blogReducer = createSlice({
  name: "blog",
  initialState: {
    successMessage: "",
    errorMessage: "",
    loader: false,
    blogs: [],
    allBlogs: [],
    totalBlogs: 0,
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },
  extraReducers: {
    [add_blog.pending]: (state, _) => {
      state.loader = true;
    },
    [add_blog.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload.error;
    },
    [add_blog.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      state.blogs = [...state.blogs, payload.blog];
    },
    [get_blogs.fulfilled]: (state, { payload }) => {
      state.totalBlogs = payload.totalBlogs;
      state.blogs = payload.blogs;
    },
    [get_all_blogs.fulfilled]: (state, { payload }) => {
      state.allBlogs = payload.allBlogs;
    },
    [delete_blog.fulfilled]: (state, { payload }) => {
      state.successMessage = payload.message;
      state.blogs = state.blogs.filter((blog) => blog._id !== payload.blogId);
    },
  },
});

export const { messageClear } = blogReducer.actions;
export default blogReducer.reducer;
